/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert, InputGroup, Card,
  NavItem, NavLink, Nav, TabPane, TabContent, Collapse,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';
import ContactSelector from '../Directory/ContactSelector';

const sourcingTypes = [
  'Manufacturer - New',
  'Manufacturer - Refurbished',
  'Aftermarket - New',
  'Harvested - New',
  'Harvested - Used',
  'Recovered and Refurbished',
];

function SupplierForm(props) {
  const { actionUrl, entity, t } = props;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isOpen, setIsOpen] = useState(0);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(t(`Supplier ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const open = (ind) => {
    if (isOpen === ind) {
      setIsOpen(-1);
    } else {
      setIsOpen(ind);
    }
  };

  const ValidationSchema = Yup.object().shape({
    name: Yup
      .string()
      .required(props.t(t('Reference is required'))),
    contact: Yup.object().shape({
      id: Yup.number(),
    }).nullable(),
    programs: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .required(t('Program is required')),
        sourcing_type: Yup.string()
          .max(45, t('Sourcing type must be 45 characters or less'))
          .oneOf(sourcingTypes, t('Select a valid sourcing type'))
          .required(t('Sourcing type is required')),
        contact_id: Yup.number(),
        lot_prefix: Yup.string(),
        payment_terms: Yup.string(),
        obligation: Yup.number(),
      }),
    ),
  });

  const handleAddProgram = (arrayHelpers) => {
    arrayHelpers.push({
      name: '',
      sourcing_type: '',
      payment_terms: '',
      contact_id: null,
      contact: null,
      is_consignment: false,
    });
  };

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="SupplierEditForm" autoComplete="off">
            <Field name="id" type="hidden" />
            <div className="row mt-4 mb-4">
              <Label
                for="sku"
                className="col-sm-3 col-form-label"
              >
                {props.t('Name')}
              </Label>
              <Col sm={7}>
                <Field
                  type="text"
                  className={`form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                  id="name"
                  name="name"
                />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="contact"
                className="col-sm-3 col-form-label"
              >
                {props.t('Contact')}
              </Label>
              <Col sm={9}>
                <ContactSelector
                  name="contact"
                  entity={values.contact}
                  onChange={(ent) => {
                    setFieldValue('contact', ent);
                  }}
                  onRemove={(ent) => {
                    setFieldValue('contact', null);
                  }}
                />
                <ErrorMessage
                  name="contact"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="sku"
                className="col-sm-3 col-form-label"
              >
                {props.t('Programs')}
              </Label>
              <Col sm={9}>
                <FieldArray name="programs">
                  {(arrayHelpers) => (
                    <>
                      <Button color="info" className="btn-sm" onClick={() => { handleAddProgram(arrayHelpers); setIsOpen(values.programs.length); }}>
                        {props.t('Add')}
                        &nbsp;
                        <span className="mdi mdi-plus" />
                      </Button>

                      <div className="accordion accordion-flush mt-3">
                        {values.programs.map((x, index) => (
                          <div key={index} className="accordion-item">
                            <h2
                              className="accordion-header"
                            >
                              <button
                                className="accordion-button fw-medium"
                                type="button"
                                onClick={() => { open(index); }}
                                style={{ cursor: 'pointer' }}
                              >
                                {x.name}
                              </button>
                            </h2>
                            <Collapse
                              isOpen={isOpen === index}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body p-0 pt-3">
                                <Row className="mb-3">
                                  <Col xs="6">
                                    <Label
                                      for={`programs_${index}_name`}
                                    >
                                      {props.t('Program Name')}
                                    </Label>
                                    <InputGroup>
                                      <Field id={`programs_${index}_name`} name={`programs[${index}].name`} type="text" className="form-control" placeholder="Name" />
                                      <Button
                                        type="button"
                                        onClick={() => arrayHelpers.remove(index)}
                                        color="danger"
                                        className="btn-soft-danger"
                                      >
                                        <span className="mdi mdi-close-thick" />
                                      </Button>
                                    </InputGroup>
                                    <ErrorMessage
                                      name={`programs[${index}].name`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Col>

                                  <Col xs="6">
                                    <Label
                                      for={`programs_${index}_lot_prefix`}
                                    >
                                      {props.t('Lot Prefix')}
                                    </Label>
                                    <Field id={`programs_${index}_lot_prefix`} name={`programs[${index}].lot_prefix`} type="text" className="form-control" />
                                    <ErrorMessage
                                      name={`programs[${index}].lot_prefix`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mt-4 mb-4">
                                  <Col sm="6">
                                    <Label
                                      for={`programs_${index}_sourcing_type`}
                                    >
                                      {props.t('Sourcing Type')}
                                    </Label>
                                    <Field
                                      as="select"
                                      className="form-select"
                                      id={`programs_${index}_sourcing_type`}
                                      name={`programs[${index}].sourcing_type`}
                                    >
                                      <option value="">{props.t('Select a sourcing type')}</option>
                                      {sourcingTypes.map((sourcingType) => (
                                        <option key={sourcingType} value={sourcingType}>
                                          {props.t(sourcingType)}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name={`programs[${index}].sourcing_type`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mt-4 mb-4">
                                  <Col sm={12}>
                                    <Label
                                      for={`programs_${index}_contact`}
                                    >
                                      {props.t('Program Contact')}
                                    </Label>
                                    <ContactSelector
                                      name={`programs[${index}].contact`}
                                      entity={values.programs[index].contact_id}
                                      onChange={(ent) => {
                                        setFieldValue(`programs[${index}].contact_id`, ent.id);
                                      }}
                                      onRemove={(ent) => {
                                        setFieldValue(`programs[${index}].contact_id`, null);
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`programs[${index}].contact`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mt-4 mb-4">
                                  <Col sm="6">
                                    {values.programs[index].is_consignment === true && (
                                      <Row className="mt-3 mb-3">
                                        <Col xs="12">
                                          <Label
                                            for={`programs_${index}_obligation`}
                                          >
                                            {props.t('Consignment Obligation')}
                                          </Label>
                                          <InputGroup>
                                            <Button type="button" className="btn btn-dark">
                                              <span className="mdi mdi-percent" />
                                            </Button>
                                            <Field id={`programs_${index}_obligation`} name={`programs[${index}].obligation`} type="text" className="form-control" />
                                          </InputGroup>
                                          <ErrorMessage
                                            name={`programs[${index}].obligation`}
                                            component="div"
                                            className="text-danger"
                                          />
                                        </Col>
                                      </Row>
                                    )}

                                    <Label>
                                      <Field
                                        type="checkbox"
                                        name={`programs[${index}].is_consignment`}
                                        checked={values.programs[index].is_consignment}
                                        onChange={(e) => {
                                          setFieldValue(`programs[${index}].is_consignment`, e.target.checked);
                                        }}
                                      />
                                      &nbsp;
                                      {t('Is Consignment?')}
                                    </Label>
                                  </Col>
                                  <Col sm="6">
                                    <Label
                                      for={`programs_${index}_payment_terms`}
                                    >
                                      {props.t('Payment Terms')}
                                    </Label>
                                    <div>
                                      <Field as="textarea" className="form-control" id={`programs_${index}_payment_terms`} name={`programs[${index}].payment_terms`} />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Collapse>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </FieldArray>
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

SupplierForm.defaultProps = {
  entity: {
    name: '',
    is_consignment: false,
  },
  onSuccess: () => {},
};

SupplierForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(SupplierForm));
